module.exports = __webpack_public_path__ + "img/ic-reply-all.40a0f03e.svg";